<template>
    <ul class="list-unstyled">
        <li class="mb-2" v-for="language in useLocaleStore().languages">
            <a :href="url(language.prefix)"
               :title="language.native_name">
                <CountryIcon :country="language.prefix" :language="true"/>
                {{ language.native_name }}
            </a>
        </li>
    </ul>
</template>

<script setup>
import { useLocaleStore } from '~/stores/LocaleStore';
const CountryIcon = defineAsyncComponent(() => import("~/components/CountryIcon.vue"));

const url = (prefix) => `/${prefix}/`;
</script>
